module.exports = __webpack_public_path__ + "static/media/GS.1d97fe94.png";